import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Classify from "../components/Classify.vue";
import List from "@/components/List.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
import EmptyNew from "@/components/EmptyNew.vue";
export default {
  name: "teacher",
  components: {
    Classify: Classify,
    List: List,
    SearchKeyWords: SearchKeyWords,
    EmptyNew: EmptyNew
  },
  data: function data() {
    return {
      attrs: [],
      attrCondition: {},
      teachers: [],
      cols: 4,
      // 列数
      params: {},
      isLoaded: false
    };
  },
  computed: {
    classifyItems: function classifyItems() {
      var _this = this;

      var items = [];
      this.attrs.forEach(function (c) {
        var item = {
          id: c.id,
          name: c.attr,
          value: {
            item: _this.attrCondition[c.id]
          },
          children: c.value
        };
        items.push(item);
      });
      return items;
    }
  },
  created: function created() {
    this.requestAttr();
    this.requestData();
  },
  watch: {
    $route: function $route() {
      this.requestData(true);
    }
  },
  // mounted() {
  //   this.$kefu()
  // },
  methods: {
    zixun: function zixun() {
      var scriptId = "script_floatbutton_" + 3;
      var script = document.getElementById(scriptId);

      if (script) {
        document.body.removeChild(script);
      }

      script = document.createElement("script");
      script.id = scriptId;
      document.body.append(script);
      script.innerHTML = "(function(a, b, c, d, e, j, s) {\na[d] = a[d] || function() {\n(a[d].a = a[d].a || []).push(arguments)\n};\nj = b.createElement(c),\ns = b.getElementsByTagName(c)[0];\nj.async = true;\nj.charset = 'UTF-8';\nj.src = 'https://visitor-static.meiqia.com/fe-widget-visitor/loader.js';\ns.parentNode.insertBefore(j, s);\n})(window, document, 'script', '_MEIQIA');\n_MEIQIA('entId', '0326e704d61ea2ba721c6ab65686097d');\n_MEIQIA(\"showPanel\");";
    },
    onListLoad: function onListLoad() {
      this.isLoaded = true;
    },
    onClickTeacher: function onClickTeacher(item) {
      this.$router.push({
        name: "ShowTeachersDetaial",
        params: {
          id: item.id
        },
        query: {
          route_name: "ShowTeachers",
          route_label: "名师",
          title: this.$route.query.title,
          recommend: this.$route.query.recommend
        }
      });
    },
    requestAttr: function () {
      var _requestAttr = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$http.get("/api/app/attribute/3");

              case 2:
                data = _context.sent;
                data.forEach(function (i) {
                  i.value && i.value.unshift({
                    id: 0,
                    name: "全部"
                  });
                  _this2.attrCondition[i.id] = 0;
                });
                this.attrs = data;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestAttr() {
        return _requestAttr.apply(this, arguments);
      }

      return requestAttr;
    }(),
    requestData: function requestData() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var ary = [];

      for (var key in this.attrCondition) {
        if (this.attrCondition[key]) {
          ary.push(this.attrCondition[key]);
        }
      }

      var params = {
        attr_val_id: ary.join(),
        keywords: this.$route.query.keywords
      };

      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }

      this.params = params;

      if (refresh) {
        this.$refs.list.searchRefresh();
      }
    },
    onClassifyChange: function onClassifyChange(_ref) {
      var id = _ref.id,
          value = _ref.value;
      this.attrCondition[id] = value.item;
      this.requestData(true);
    }
  }
};